import quillConfig from '@/quill/config'

/**
 * Toolbar for a ticket's description (the ticket form and the running-session
 * drawer, both desks). A ticket is a work item, not CMS content or a letter:
 * it quotes what the requester said, carries error messages, log lines and
 * URLs, and lists what is left to do. So it gets what ticket tools converge
 * on - two heading levels, lists incl. a checklist, blockquote, code block and
 * inline code, links - and not what belongs elsewhere: H1/H4 and alignment
 * are page-section typography, `placeholder` inserts template variables that
 * mean nothing on a ticket.
 *
 * `blockquote` is the shared multi-line container from config.js, `list:
 * check` is Quill's checklist (Markdown-style "[ ] " / "[x] " prefixes are
 * already wired in the shared keyboard bindings).
 */
const ticketQuillConfig = {
    ...quillConfig,
    modules: {
        ...quillConfig.modules,
        toolbar: {
            container: [
                ['bold', 'italic', 'underline', 'strike'],
                [{ header: '2' }, { header: '3' }],
                [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
                ['blockquote', 'code', 'code-block'],
                ['link'],
                ['text-generation'],
                ['clean']
            ]
        }
    }
}

export default ticketQuillConfig
